
import img_pt from '@/assets/images/topSearch/img_pt.png'
import img_zy from '@/assets/images/topSearch/img_zy.png'
import img_sg from '@/assets/images/topSearch/img_sg.png'
import img_kj from '@/assets/images/topSearch/img_kj.png'
import img_hy from '@/assets/images/topSearch/img_hy.png'
import img_dy from '@/assets/images/topSearch/img_dy.png'
import img_jcal from '@/assets/images/topSearch/img_jcal.png'


const editionList = [
    {
        name:'标准版',
        id:0,
        type:'putong',
        img:img_pt,
        pathName:'search',
    },
    {
        name:'专业版',
        id:1,
        type:'zhuanye',
        img:img_zy,
        pathName:'searchZY',
    },
    {
        name:'税干版',
        id:2,
        type:'shuigan',
        img:img_sg,
        pathName:'searchSG',
    },
    {
        name:'会计版',
        id:3,
        type:'kuaiji',
        img:img_kj,
        pathName:'searchKJ',
    },
    // {
    //     name:'行业版',
    //     id:4,
    //     type:'hangye',
    //     img:img_hy,
    //     pathName:'searchHY',
    // },
    {
        name:'答疑版',
        id:5,
        type:'dayi',
        img:img_dy,
        pathName:'searchDY',
    },
    {
        name:'稽查案例版',
        id:6,
        type:'jichaanli',
        img:img_jcal,
        pathName:'searchJCAL',
    },
]

const typeList = [
    {
        name:'查全文',
        id:0,
        type:'putong',
    },
    {
        name:'查标题',
        id:1,
        type:'title',
    },
    {
        name:'查文号',
        id:2,
        type:'articol',
    },
    {
        name:'查时间',
        id:3,
        type:'time',
    },
]

//普适版 的搜索分类
const psbSearchType = [
    {
        name:'答疑',
        childs:[
            {
                name:'税务总局答疑',
                categoryId:'4025',
            },
            {
                name:'地方税务局答疑',
                categoryId:'4026',
            },
            {
                name:'专家答疑',
                categoryId:'4027',
            }
        ]
    },
    {
        name:'法规',
    },
    {
        name:'解读',
    },
    {
        name:'专题',
    },
    {
        name:'税率',
    },
    {
        name:'实务',
    },
    {
        name:'案例',
    },
    {
        name:'稽查',
    }
]

export {
    editionList,
    typeList,
    psbSearchType
}